import { GetStaticProps } from 'next';
import { IAccountDetailsPageData } from '../../../features/account/domain/pages/IAccountDetailsPageData';
import { ParkingBookingsPage } from '../../../features/parking/ui/my-bookings/overview/ParkingBookingsPage';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { ParkingPageId } from '../../../features/parking/domain/pages/ParkingPageId';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IAccountDetailsPageData> =
	createGetStaticPropsWithPage(ParkingPageId.ParkingBookings);

export default ParkingBookingsPage;
